import styled, { css } from 'styled-components';

export const verticalContainerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const OffersContainer = styled.div`
  ${verticalContainerStyles};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const FeaturesContainer = styled.div<{
  isOverlay: boolean;
  soldOut?: boolean;
  useColumnLayout?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ isOverlay, soldOut }) =>
    !isOverlay &&
    !soldOut &&
    css`
      border-top: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
      padding-top: 16px;

      @media (max-width: 768px) {
        padding-top: 12px;
      }
    `}

  ${({ soldOut, useColumnLayout }) =>
    !soldOut &&
    css`
      @container card-container (min-width: 960px) {
        ${
          useColumnLayout
            ? css`
                flex-direction: row;
                align-items: flex-start;
                gap: 24px;
              `
            : css`
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-auto-flow: dense;
                align-items: start;
                column-gap: 24px;
              `
        }
      }
    `}
`;
